(function(){
    'use strict';
    angular.module('Directives').directive('bbaDetailsDate', bbaDetailsDate);

    function bbaDetailsDate(){
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/bbaDetailsDate.html',
            scope: {
                ngModel: '=',
                header: '=?',
                ngDisabled: '=?'
            },
            link: bbaDetailsDateLink
        };

        function bbaDetailsDateLink($scope, $attrs, $element){
            // Test values only 
            $scope.dateOptions = {
                'dateFormat': 'yy-mm-dd',
                'setDate': 'today',
            }
            $scope.options = [{
                name: 'N/A'
            }];
            $scope.testData = {
                name: 'N/A'
            }
            $scope.checkboxTestData = {
                name: 'N/A'
            }
        }
    }
})()


// WEBPACK FOOTER //
// ./js/directives/bbaDetailsDate.js